import { Modal } from 'antd'
import { getProps } from '../props'
import deleteClientSite from '../Services/delete'

export default () => (dispatch) => {

  const { clientSite } = getProps()

  Modal.confirm({
    title: `Delete "${clientSite.name}"`,
    content: 'Are you sure to delete this site?',
    okText: 'Yes',
    width: 400,
    onOk: () => dispatch(deleteClientSite()),
  })

}
